import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, msg: String(error && (error.message || error)) };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          dir="rtl"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            background: "#0f1c33",
            color: "#fff",
            padding: 24,
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
          data-testid="error-boundary-screen"
        >
          <div style={{ fontSize: 40 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>حدث خطأ غير متوقع</div>
          <div style={{ fontSize: 14, opacity: 0.7 }}>نعتذر عن الإزعاج، يرجى إعادة المحاولة</div>
          {this.state.msg && (
            <div dir="ltr" style={{ fontSize: 11, opacity: 0.5, maxWidth: 320, wordBreak: "break-word" }} data-testid="error-boundary-detail">
              {this.state.msg}
            </div>
          )}
          <button
            data-testid="error-boundary-reload-btn"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              padding: "12px 32px",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            إعادة المحاولة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
